import Cookies from 'js-cookie';
const TokenKey = 'token';
const RefreshTokenKey = 'refreshToken';

export function getToken() {
  return Cookies.get(TokenKey);
}
export function setTokenRember(token) {
  return Cookies.set(TokenKey, token, { expires: 5 });
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}
export function setRefreshToken(refreshToken) {
  return Cookies.set(RefreshTokenKey, refreshToken, { expires: 5 });
}
export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey);
}

// Cookies存储
export function setCookies(key, value) {
  Cookies.set(key, value, { expires: 5 });
}
export function getCookies(key) {
  return Cookies.get(key);
}
export function clearOneCookies(key) {
  Cookies.remove(key);
}

// localStorage存储
export function setLocal(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}
export function getLocal(key) {
  return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : {};
}
export function clearOneLocal(key) {
  localStorage.removeItem(key);
}
export function clearAllLocal() {
  localStorage.clear();
}

// setSession存储
export function setSession(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}
export function getSession(key) {
  return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key)) : {};
}
export function clearOneSession(key) {
  sessionStorage.removeItem(key);
}
export function clearAllSession() {
  sessionStorage.clear();
}
